/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_EmptyInputs */

const cs_demands_empty = /** @type {(inputs: Demands_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné poptávky. Přidejte je u klienta, nebo vytvořte novou zde.`)
};

const en_demands_empty = /** @type {(inputs: Demands_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No demands yet. Add one on a client, or create a new demand here.`)
};

/**
* | output |
* | --- |
* | "No demands yet. Add one on a client, or create a new demand here." |
*
* @param {Demands_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_empty = /** @type {((inputs?: Demands_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_empty(inputs)
	return cs_demands_empty(inputs)
});